import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LocationType } from '../models/Enums';
import { LocationConfirmInfo } from '../models/LocationConfirmInfo';
import { LocationConfirmationService } from '../services/location-confirmation.service';

@Component({
    selector: 'location-confirm-report',
    templateUrl: 'location-confirm-report.component.html',
    styles: [],
    standalone: false
})
export class LocationConfirmReportComponent implements OnInit, AfterViewInit {

    constructor(private _locationConfirmService: LocationConfirmationService, private route: ActivatedRoute, private sanitizer: DomSanitizer) {

    }

    errorMessage: string = '';
    reportReady: boolean = false;
    pdfUrl: SafeResourceUrl | undefined;
    iframeHeight: string = '600px';
    locationType: string = 'Origin';


    getReport() {
        //{ path: 'locationconfirmreport/:lt/:loc/:start/:end/:id/:bbd/:udd/:sc/:st/:sl/:scs/:sln/:scust/:hut/:slnum/:sdrv/:splt'

        let confirmInfo: LocationConfirmInfo = new LocationConfirmInfo();
        let parmLocType: string = this.route.snapshot.params['lt'];
        confirmInfo.locationType = +parmLocType as LocationType;
        confirmInfo.locCode = this.route.snapshot.params['loc'];
        confirmInfo.periodStartDate = this.route.snapshot.params['start'];
        confirmInfo.periodEndDate = this.route.snapshot.params['end'];
        confirmInfo.locationId = this.route.snapshot.params['id'];
        confirmInfo.breakoutByDay = this.route.snapshot.params['bbd'] == 'true';
        confirmInfo.useDeliveryDate = this.route.snapshot.params['udd'] == 'true';
        confirmInfo.showContract = this.route.snapshot.params['sc'] == 'true';
        confirmInfo.showTrucker = this.route.snapshot.params['st'] == 'true';
        confirmInfo.showLocation = this.route.snapshot.params['sl'] == 'true';
        confirmInfo.showCityState = this.route.snapshot.params['scs'] == 'true';
        confirmInfo.showLoadNumber = this.route.snapshot.params['sln'] == 'true';
        confirmInfo.showCustomer = this.route.snapshot.params['scust'] == 'true';
        confirmInfo.hideUnassignedTrucker = this.route.snapshot.params['hut'] == 'true';
        confirmInfo.showLoadNumbers = this.route.snapshot.params['slnum'] == 'true';
        confirmInfo.showDriverName = this.route.snapshot.params['sdrv'] == 'true';
        confirmInfo.showPlateNumber = this.route.snapshot.params['splt'] == 'true';

        this.locationType = confirmInfo.locationType == LocationType.Origin ? 'Origin' : 'Destination';

        if (confirmInfo.locationId > 0) {
            this._locationConfirmService.getReportContent(confirmInfo).subscribe({
                next: data => {
                    const url = URL.createObjectURL(data);
                    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                    this.reportReady = true;
                },
                error: err => {
                    this.errorMessage = err;
                    this.reportReady = true;
                }
            });
        }
        else {
            this.reportReady = true;
        }
    }

    ngOnInit(): void {
        this.getReport();
       
    }

    ngAfterViewInit(): void {
        this.iframeHeight = `${window.innerHeight - 100}px`;
    }
    
}
